import React from 'react';
import { checkForChanges } from '../utilities';

const SelectItem = ({ item, isSelected, id, onSelectionChange, selectedItems }) => {

	// ADD CLASSNAMES BASED ON PAGE STATUS (SELECTED, UNSELECTED)
	let className = 'page-item mv1 bg-light-gray mv1 dim pointer pv3 ph2 ';
	className += isSelected ? 'selected' : '';

	const status = item.querySelector('status').textContent;
	const isNotPubliclyPublished = status !== 'publish' && status.length > 0;
	const postDate = item.querySelector('post_date').textContent;
	let lastModified = '';

	// GET THE LAST-MODIFIED DATE OF NON-PUBLISHED PAGES 
	if ( status !== 'publish' ) {

		const metas = item.querySelectorAll('meta_key');
		for(const meta in metas) {

			if ( metas[meta].textContent === "_edit_last" ) {

				lastModified = metas[meta].nextElementSibling.textContent;
			}
		}
	}
	const dateToDisplay = lastModified.length > 0 ? 
		'last modified ' + (lastModified - 1) + ' months ago more or less.' :
		'published on ' + postDate;

	// SHOW/HIDE SAVE BUTTON BASED ON TOGGLED PAGES
	const togglePageSelect = (event) => {

		event.target.classList.toggle('selected');

		const pageList = event.target.parentNode;
		const newSelectedPages = Array.from(pageList.querySelectorAll('.selected'));
		const hasChanges = checkForChanges(selectedItems, newSelectedPages);

		document.querySelector('.manage-changes').style.display = hasChanges ? 'block' : 'none';
	}	


	return (
		<li className={className} data-id={id} onClick={ (e) => togglePageSelect(e) }>

			{ 
				(isNotPubliclyPublished) ? <span className='red'>( { status } )</span> : ''
			}

			<span className='ml2 dim pointer'>{ item.querySelector('title').textContent }</span>

			{
				(isNotPubliclyPublished) ? <small className='red'> ( { dateToDisplay } )</small> : '' 
			}

		</li>
		)
}

export default SelectItem;